import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=39982a6c"
import script from "./Shipping.vue?vue&type=script&lang=js"
export * from "./Shipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports